<div class="emds">
    <div class="modal-default modal-flex" [formGroup]="form">
        <div class="modal-header">
            <span id="medication-modal-header-title" translate>Save As</span>
        </div>

        <div class="modal-body remove-padding">
            <div class="form-group">
                <label for="save-as-id" translate>ID</label>
                <input
                    id="save-as-id"
                    class="form-control"
                    type="text"
                    formControlName="id"
                />
            </div>
            <div class="form-group">
                <label for="save-as-name" translate>Name</label>
                <input
                    id="save-as-name"
                    class="form-control required"
                    [class.error]="nameControl?.invalid && (nameControl?.touched || isSubmitted)"
                    type="text"
                    formControlName="name"
                    required
                />
                <div class="incorrect-input" *ngIf="nameControl?.invalid && (nameControl?.touched || isSubmitted)">
                    <span translate>Name is required.</span>
                </div>
            </div>
        </div>

        <div class="modal-footer">
            <button class="btn btn-primary" type="button" (click)="onSaved()" [disabled]="form.invalid && isSubmitted" translate>Save</button>
            <button class="btn btn-secondary" type="button" (click)="onCancel()" translate>Cancel</button>
        </div>
    </div>
</div>